import { IonItem, IonList, IonGrid, IonCol, IonRow, IonImg, IonLabel, IonThumbnail } from "@ionic/react";
import React from "react";
import { services } from '../services';


const AppSelectionList: React.FC = () => { 
  // routes to service component
  const rows = [...Array(Math.ceil(services.length))];
  
  const serviceRows = rows.map((row, i) => services.slice(i * 4, i * 4 + 4))

  const content = serviceRows.map((row, i) => (
    <IonRow key={i}>
      {row.map((service) => {
        return (
        <IonCol key={service.service + service.id} >
          <IonItem className="icon" lines={'none'} button key={service.service} routerLink={`/my/${service.service}`}>
            <IonThumbnail>
              <IonImg className="icon" src={service.logo} key={service.id} /> 
            </IonThumbnail>
            <IonLabel className='ion-text-center'>{service.service}</IonLabel>            
          </IonItem>
        </IonCol>
        )
      })}
    </IonRow>    
  ))


     
    
  return (
    <IonGrid className="app-selection-list">
      {content}
    </IonGrid>

  )
}

export default AppSelectionList;

{/* <IonList>
{services.map((service) => 
  <IonItem button key={service.id} routerLink={`/my/${service.service}`}>
    {service.logo}
    {service.service}
  </IonItem>
)}
</IonList> */}